import declare from "dojo/_base/declare";
import { ButtonEnum } from "designSystem/types/button-types";
import Widget from "csi/wizard/Widget";

const {
	BUTTON_FINISH_GO,
} = ButtonEnum;

const NewFoodSKUSRLineItemWizard = declare(Widget, {
	/**
	 * @override
	 * Remove the Finish and Go button.
	 */
	canShowButton: function(idAction) {
		return (idAction === BUTTON_FINISH_GO) ? false : this.inherited(arguments);
	},
});

export = NewFoodSKUSRLineItemWizard;